import { useQuery } from "@tanstack/react-query";
import { useLumanityServices } from "@lumanity/ui";
import { listThreads } from "@lumanity/ui/chat";

export function useChatThreads(projectId: string | undefined) {
  const { chatApiClient } = useLumanityServices();
  return useQuery({
    queryKey: ["chat-threads", projectId],
    queryFn: () => listThreads(chatApiClient, projectId!),
    enabled: !!projectId,
  });
}
